module.exports = __webpack_public_path__ + "static/media/sliderimage5.ca87eb62.jpg";